






















import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";

import { Zone } from "../../models/zone/zone.model";
import { IZone } from "../../models/interfaces/zone/zone.model.interface";

import ZoneDetails from "@/components/zone/ZoneDetails.vue";
import ZoneProductCategories from "@/components/zone/ZoneProductCategories.vue";
import ZoneContentTypes from "@/components/zone/ZoneContentTypes.vue";
import ZoneEnhancements from "@/components/zone/ZoneEnhancements.vue";
import ZoneContentSetsTable from "@/components/zone/ZoneContentSetsTable.vue";
import ZoneTag from "@/components/zone/ZoneTag.vue";

const ZoneManagementModule = namespace("zoneManagementModule");

@Component({
  components: {
    ZoneDetails,
    ZoneProductCategories,
    ZoneContentTypes,
    ZoneEnhancements,
    ZoneContentSetsTable,
    ZoneTag
  }
})
export default class ZoneManager extends Vue {
  @ZoneManagementModule.Getter public zone;
  @ZoneManagementModule.Action public retrieveZone;

  get getZoneModel(): IZone {
    return this.zone;
  }

  @Prop() public zoneId: number;

  @Provide() public zoneModel: IZone = new Zone();

  private loading: boolean = false;

  @Watch("getZoneModel", { deep: true })
  public onZoneUpdate() {
    this.zoneModel = this.zone;
  }

  public created() {
    this.getZone(this.zoneId);
  }

  private getZone(id: number) {
    this.loading = true;
    this.retrieveZone(id).then((result) => {
      if (this.zone) {
        this.zoneModel = this.zone;
        this.loading = false;
      }
    });
  }
}
